import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { buildDesktopInquiryPath } from './chatUiPolicy';

/** 일반·축소 채팅에서 같은 검증과 라우트를 쓰는 명시적 견적상세 버튼입니다. */
export default function ChatInquiryDetailButton({ reservationId, compact = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const inquiryPath = buildDesktopInquiryPath(reservationId);

  return (
    <Button
      type="default"
      size="small"
      disabled={!inquiryPath}
      aria-label={t('견적상세')}
      onPointerDown={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      onClick={() => {
        if (inquiryPath) navigate(inquiryPath);
      }}
      style={{
        height: compact ? 24 : 28,
        padding: compact ? '0 7px' : '0 9px',
        fontSize: compact ? 11 : 12,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {t('견적상세')}
    </Button>
  );
}
